export function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
export function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}
